module.exports = __webpack_public_path__ + "static/media/ext.16b2b8ce.png";